import {gql} from '@apollo/client';

import {CheckInFragment} from '#component/page/ActionPlan/components/CheckInSection/CheckInSection.types';

import {ActionPlanFragment} from './ActionPlan.types';

export const actionPlanPageQuery = gql`
  ${ActionPlanFragment}
  ${CheckInFragment}
  query ActionPlanPageQuery {
    me {
      id
      subscription {
        id
        hasActiveSubscription
        hasMembership
      }
      userProfile {
        id
        firstName
      }
      mostRecentLabSubmission {
        id
        userSurveySubmission {
          id
        }
      }
      mostRecentLabSubmissionWithResults {
        id
        registeredDate
        labAssessment {
          deltaAge
          id
        }
        userSurveySubmission {
          id
          surveyAssessment {
            id
            submissionId
            actionPlans {
              ...ActionPlanFragment
            }
          }
        }
      }
      completedActionPlanOnboarding
    }
    currentCheckIn {
      id
      ...CheckInFragment
    }
    currentTestPeriod {
      checkInStats(input: {includeCurrentCheckIn: true}) {
        completed
        endedOn
        startedOn
      }
      id
      startedAt
    }
  }
`;
